var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "emd-alert",
        {
          staticClass: "eu-mb_5",
          attrs: { variant: "warning", "no-close": "" },
        },
        [
          _c("template", { slot: "content" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("description")) + " ")]),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }